/* eslint-disable no-console */
const main = async (proxy = null) => {
    try {
        const { headers } = await fetch(window.location.href, { method: 'GET' });
        proxy = new URL(headers.get('x-bud-proxy-origin')).href;
    }
    catch (err) {
        return console.error(`There was an issue requesting ${window.location.href} (it should be the current page).`, err);
    }
    try {
        setInterval(() => [
            [document.getElementsByTagName('a'), 'href'],
            [document.getElementsByTagName('link'), 'href'],
        ]
            .map(([elements, attribute]) => [Array.from(elements), attribute])
            .forEach(([elements, attribute]) => elements
            .filter(el => el.hasAttribute(attribute))
            .filter(el => !el.hasAttribute('__bud_processed'))
            .filter(el => el.getAttribute(attribute).startsWith(proxy))
            .map(el => {
            const value = el.getAttribute(attribute);
            console.info(`replacing ${attribute} on ${el.tagName} with value of ${value}`);
            el.setAttribute(attribute, value.replace(proxy, '/'));
            el.setAttribute('__bud_processed', '');
        })), 1000);
    }
    catch (err) {
        return console.error(`There was a problem replacing hrefs for the proxied server. Exiting script early.`, err);
    }
};
(async () => window.requestAnimationFrame(async function ready() {
    return document.body
        ? await main()
        : window.requestAnimationFrame(ready);
}))();
